import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { TenantService } from '@core/tenant/tenant.service';

@Injectable({
  providedIn: 'root'
})
export class AppointmentScheduleGuard implements CanActivate {
    constructor(
    private tenantService: TenantService,
    private router: Router
  ) { }

    canActivate(): boolean {
      if(this.tenantService.currentTenant.flexibleSchedule) return true;
      
      this.router.navigate(['/']);
      return false;
  }
}